// Patterns are built with new RegExp from \uXXXX string escapes so the code
// points stay readable in source instead of becoming literal invisible chars.

// Line breaks / tabs -> single space: TAB, LF, VT, FF, CR, NEL, LS, PS.
// eslint-disable-next-line prefer-regex-literals
const LINE_BREAKS_AND_TABS = new RegExp(
  '[\\t\\n\\v\\f\\r\\u0085\\u2028\\u2029]+',
  'g',
)

// Zero-width chars, word joiner and BOM -> dropped (truly invisible).
// eslint-disable-next-line prefer-regex-literals
const ZERO_WIDTH_AND_BOM = new RegExp('[\\u200B-\\u200D\\u2060\\uFEFF]', 'g')

// Remaining non-printable control chars -> dropped: C0 (minus the whitespace
// handled above), DEL and the C1 block.
/* eslint-disable prefer-regex-literals, no-control-regex -- intentional: strips non-printable control chars */
const CONTROL_CHARS = new RegExp(
  '[\\u0000-\\u0008\\u000E-\\u001F\\u007F-\\u009F]',
  'g',
)
/* eslint-enable prefer-regex-literals, no-control-regex */

// Exotic Unicode spaces -> regular space: NBSP, ogham, en/em quad family,
// narrow/medium math space, ideographic space.
// eslint-disable-next-line prefer-regex-literals
const UNICODE_SPACES = new RegExp(
  '[\\u00A0\\u1680\\u2000-\\u200A\\u202F\\u205F\\u3000]',
  'g',
)

/**
 * Sanitizes a cell value coming from Excel/CSV, removing characters the user
 * never sees in the spreadsheet but that corrupt downstream parsing (rows split
 * across lines, fields with hidden control chars, broken numbers, etc.).
 */
export function removeUnwantedCharsForCVS(content: string): string {
  return content
    .toString()
    .replace(LINE_BREAKS_AND_TABS, ' ')
    .replace(ZERO_WIDTH_AND_BOM, '')
    .replace(CONTROL_CHARS, '')
    .replace(UNICODE_SPACES, ' ')
    .replace(/ {2,}/g, ' ') // collapse the runs of spaces the steps may produce
}
